import React from "react";
import { useNotifications } from "../../context/NotificationContext";

const TYPE_ICONS: Record<string, string> = {
  info: "i",
  success: "\u2713",
  warning: "!",
  error: "\u2717",
};

const ToastContainer: React.FC = () => {
  const { toasts, dismissToast } = useNotifications();

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`toast toast--${toast.notification_type}`}
        >
          <span className="toast-icon">
            {TYPE_ICONS[toast.notification_type] || "i"}
          </span>
          <div className="toast-body">
            <div className="toast-title">{toast.title}</div>
            <div className="toast-message">{toast.message}</div>
          </div>
          <button
            className="toast-close"
            onClick={() => dismissToast(toast.id)}
            aria-label="Dismiss"
          >
            \u00d7
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
